import * as api from './api/redux'
import * as app from './app/redux'
import * as auth from './auth/redux'
import * as example from './example/redux'
import * as articles from './articles/redux'
import * as messages from './messages/redux'
import * as mail from './mail/redux'

export const actions = {
  app: app.actions,
  api: api.actions,
  auth: auth.actions,
  example: example.actions,
  articles: articles.actions,
  messages: messages.actions,
  mail: mail.actions,
}

export const selectors = {
  app: app.selectors,
  api: api.selectors,
  auth: auth.selectors,
  example: example.selectors,
  articles: articles.selectors,
  messages: messages.selectors,
  mail: mail.selectors,
}

export const reducers = {
  app: app.reducer,
  api: api.reducer,
  auth: auth.reducer,
  example: example.reducer,
  articles: articles.reducer,
  messages: messages.reducer,
  mail: mail.reducer,
}
